import { MAIN_ROUTES } from "./routes";

export const NAV_OPTIONS = new Map([
  ["ABOUT", MAIN_ROUTES.get("ABOUT")],
  // ["PUBLICATIONS", MAIN_ROUTES.get("PUBLICATIONS")],
  ["CONTACT", MAIN_ROUTES.get("CONTACT")],
]);

export const LANGUAGES_OPTIONS = new Map([
  [
    "ENGLISH",
    {
      LABEL: "English",
      KEY: "en",
    },
  ],
  [
    "CHINESE",
    {
      LABEL: "中文",
      KEY: "zh",
    },
  ],
]);
